module.exports = __webpack_public_path__ + "static/img/evolucao-respostas-area.80ebc96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolucao-respostas-area.png
// module id = zEdS
// module chunks = 1